export default {
  // Date picker
  dateRangeSeparator: "→",
  startDatePlaceholder: "Start Date",
  endDatePlaceholder: "End Date",

  // Buttons
  reset: "Reset",
  query: "Query",

  // Data statistics
  totalData: "Total {count} records",

  // Loading
  loading: "Loading...",

  // Behavior types
  withdrawal: "Withdrawal",
  deposit: "Deposit",
  buy: "Buy",
  sell: "Sell",
  unknown: "Unknown",

  // Load more
  loadMore: "Load More Data",
  collapse: "Collapse",

  // Empty state
  noData: "No Data",
};
